import React from 'react';
import { styled } from '@mui/material/styles';
import {
	Grid,
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableCell,
	TableHead,
	TableRow,
	Typography,
	IconButton,
} from '@mui/material';
import moment from 'moment';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { CampaignPayment } from '@horasys/bellplus/common/types';

const PREFIX = 'PaymentTable';

const classes = {
	head: `${PREFIX}-head`,
	body: `${PREFIX}-body`,
	root: `${PREFIX}-root`,
	formElement: `${PREFIX}-formElement`,
	selectEmpty: `${PREFIX}-selectEmpty`,
	uploadInput: `${PREFIX}-uploadInput`,
	errorMessage: `${PREFIX}-errorMessage`,
	uploadWrapper: `${PREFIX}-uploadWrapper`,
	paperchildGrid: `${PREFIX}-paperchildGrid`,
	saveGrid: `${PREFIX}-saveGrid`,
	margin: `${PREFIX}-margin`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
	[`& .${classes.formElement}`]: {
		margin: theme.spacing(0.5),
		minWidth: '100%',
	},

	[`& .${classes.selectEmpty}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.uploadInput}`]: {
		fontSize: '100px',
		position: 'absolute',
		left: 0,
		top: 0,
		opacity: 0,
	},

	[`& .${classes.errorMessage}`]: {
		color: 'red',
	},

	[`& .${classes.uploadWrapper}`]: {
		position: 'relative',
		overflow: 'hidden',
		display: 'inline-block',
	},

	[`& .${classes.paperchildGrid}`]: {
		padding: theme.spacing(3),
	},

	[`& .${classes.saveGrid}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.margin}`]: {
		margin: theme.spacing(1),
	},
}));

export default function PaymentTable({
	payments,
	handleDelete,
	handleEdit,
	handleView,
	isActionsEnabled,
}: {
	payments: Array<CampaignPayment>;
	handleDelete?: any;
	handleEdit?: any;
	handleView?: any;
	isActionsEnabled: any;
}) {
	const openPaymentDetails = ({ rowData }: { rowData: any }) => {
		handleView(rowData);
	};

	const StyledTableCell = TableCell;

	const StyledTableRow = TableRow;

	return (
		<StyledGrid container>
			{' '}
			{payments && payments.length > 0 && (
				<>
					<Grid item xs={12}>
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow style={{backgroundColor:"#042630",color:"#ffffff"}}>
										<StyledTableCell
											align="center"
                      style={{color:"#ffffff"}}
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Amount
										</StyledTableCell>
										<StyledTableCell
                    style={{color:"#ffffff"}}
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Net Amount
										</StyledTableCell>
										{/* <StyledTableCell align="center">
											{' '}
											Discount
										</StyledTableCell> */}
										<StyledTableCell
                    style={{color:"#ffffff"}}
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Method
										</StyledTableCell>
										{/* <StyledTableCell align="center">
											{' '}
											Options
										</StyledTableCell> */}
										<StyledTableCell
                    style={{color:"#ffffff"}}
											align="center"
											classes={{
												head: classes.head,
												body: classes.body,
											}}>
											{' '}
											Description{' '}
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{payments != null &&
										payments.map(
											(data: CampaignPayment, index: any) => {
												if (
													data.amount !== null &&
													data.amount !== undefined
												) {
													return (
														<StyledTableRow
															key={index}
															classes={{
																root: classes.root,
															}}>
															<StyledTableCell
																align="center"
																component="th"
																scope="row"
																classes={{
																	head: classes.head,
																	body: classes.body,
																}}>
																<Typography>
																	{' '}
																	{data.totalAmount}
																</Typography>
															</StyledTableCell>
															<StyledTableCell
																align="center"
																component="th"
																scope="row"
																classes={{
																	head: classes.head,
																	body: classes.body,
																}}>
																<Typography>
																	{' '}
																	{data.totalAmount -
																		((data.discount
																			? data.discount
																			: 0) /
																			100) *
																			data.totalAmount}
																</Typography>
															</StyledTableCell>
															{/* <StyledTableCell
																align="center"
																component="th"
																scope="row">
																<Typography>
																	{' '}
																	{data.discount
																		? data.discount
																		: 0}
																	%
																</Typography>
															</StyledTableCell> */}
															<StyledTableCell
																align="center"
																component="th"
																scope="row"
																classes={{
																	head: classes.head,
																	body: classes.body,
																}}>
																<Typography>
																	{' '}
																	{data.method &&
																		data.method.toUpperCase()}
																</Typography>
															</StyledTableCell>
															{/* <StyledTableCell
																align="center"
																component="th"
																scope="row">
																<Typography>
																	{' '}
																	{data.option &&
																		data.option.toUpperCase()}
																</Typography>
															</StyledTableCell> */}
															<StyledTableCell
																align="center"
																component="th"
																scope="row"
																classes={{
																	head: classes.head,
																	body: classes.body,
																}}>
																<Typography>
																	{' '}
																	{data.description}
																</Typography>
															</StyledTableCell>
														</StyledTableRow>
													);
												} else return <></>;
											},
										)}
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</>
			)}
		</StyledGrid>
	);
}
